export default {
  setCompetencyTest (state, { competencyTest }) {
    state.competencyTest = competencyTest
  },

  setCompetencyTestEvaluation (state, { evaluation }) {
    state.evaluation = evaluation
  },

  resetCompetencyTestEvaluation (state) {
    state.evaluation = {}
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/surveys/mutations.js